import { useState, useEffect } from 'react';
import { fetchMyActivities, fetchReportActivities } from '../../../services/dashboardService';

export function useMyActivities() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMyActivities()
      .then((response) => {
        // Handle wrapped response from authenticatedRequest
        let activitiesArray = [];
        if (response && response.data) {
          // Response is wrapped: {success: true, status: 200, data: [...]}
          activitiesArray = Array.isArray(response.data) ? response.data : [];
        } else if (Array.isArray(response)) {
          // Response is direct array
          activitiesArray = response;
        } else if (response && (response.results || response.activities)) {
          // Response has results or activities property
          activitiesArray = response.results || response.activities || [];
        }
        
        setActivities(activitiesArray);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || 'Failed to load activities');
        setActivities([]);
        setLoading(false);
      });
  }, []);
  return { activities, loading, error };
}

export function useReportActivities() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchReportActivities()
      .then((response) => {
        console.log('Raw API response:', response);
        console.log('Is array?', Array.isArray(response));
        
        // Handle wrapped response from authenticatedRequest
        let activitiesArray = [];
        if (response && response.data) {
          // Response is wrapped: {success: true, status: 200, data: [...]}
          activitiesArray = Array.isArray(response.data) ? response.data : [];
        } else if (Array.isArray(response)) {
          // Response is direct array
          activitiesArray = response;
        } else if (response && (response.results || response.activities)) {
          // Response has results or activities property
          activitiesArray = response.results || response.activities || [];
        }
        
        console.log('Activities array:', activitiesArray);
        setActivities(activitiesArray);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching activities:', err);
        setError(err.message || 'Failed to load report activities');
        setActivities([]); // Set empty array on error
        setLoading(false);
      });
  }, []);
  return { activities, loading, error };
}
